import React from 'react';
import { Calendar } from 'lucide-react';
import { Button } from './ui/button';
import { useLanguage } from '../context/LanguageContext';

const HeroSection = ({ scrollToSection }) => {
  const { t } = useLanguage();

  return (
    <section id="hero" className="pt-32 pb-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-emerald-950/80 via-emerald-900/75 to-amber-900/70"></div>
        <img src="https://images.pexels.com/photos/8525000/pexels-photo-8525000.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" alt="Family Protection" className="w-full h-full object-cover" />
      </div>
      <div className="container mx-auto relative z-10">
        <div className="max-w-3xl">
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight animate-in fade-in slide-in-from-bottom duration-700" data-testid="hero-title">
            {t('hero_title')}
          </h1>
          <p className="text-xl sm:text-2xl text-slate-100 mb-8 leading-relaxed animate-in fade-in slide-in-from-bottom duration-700 delay-150">
            {t('hero_subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 animate-in fade-in slide-in-from-bottom duration-700 delay-300">
            <Button onClick={() => scrollToSection('contact')} size="lg" className="bg-amber-700 hover:bg-amber-800 text-white text-lg px-8 py-6 shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105" data-testid="hero-cta-consult">
              {t('hero_cta_consult')}
            </Button>
            <Button
              onClick={() => {
                if (window.Calendly) {
                  window.Calendly.initPopupWidget({ url: 'https://calendly.com/ivonne-solvidafinancial/15min' });
                }
              }}
              size="lg"
              variant="outline"
              className="bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white border-2 border-amber-300 text-lg px-8 py-6 transition-all duration-300 hover:scale-105 flex items-center gap-2"
              data-testid="hero-cta-appointment"
            >
              <Calendar className="w-5 h-5" />
              {t('hero_cta_appointment')}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
